import { RESOURCES as en } from "./english";
import { RESOURCES as de } from "./german";
import { RESOURCES as ru } from "./russian";
import { RESOURCES as sk } from "./slovak";
import { RESOURCES as uk } from "./ukrainian";

const RESOURCES = {
  en,
  uk,
  de,
  sk,
  ru,
};

export { RESOURCES };
